import { useEffect } from "react";

// Injects Google Analytics (GA4), Google Tag Manager, Meta Pixel and social
// meta tags into <head> based on admin-configured settings.
export const TrackingTags = ({ settings }) => {
  useEffect(() => {
    if (!settings) return;

    const added = [];
    const addScript = (id, inner, src) => {
      if (document.getElementById(id)) return;
      const el = document.createElement("script");
      el.id = id;
      if (src) {
        el.async = true;
        el.src = src;
      } else {
        el.innerHTML = inner;
      }
      document.head.appendChild(el);
      added.push(el);
    };

    // GA4
    if (settings.google_analytics_id) {
      const gid = settings.google_analytics_id;
      addScript("ga-lib", null, `https://www.googletagmanager.com/gtag/js?id=${gid}`);
      addScript(
        "ga-init",
        `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${gid}');`
      );
    }

    // Google Tag Manager
    if (settings.google_tag_manager_id) {
      addScript(
        "gtm-init",
        `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${settings.google_tag_manager_id}');`
      );
    }

    // Meta (Facebook) Pixel
    if (settings.meta_pixel_id) {
      addScript(
        "meta-pixel",
        `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${settings.meta_pixel_id}');fbq('track','PageView');`
      );
    }

    // Social / OG meta tags
    const setMeta = (attr, key, content) => {
      if (!content) return;
      let tag = document.querySelector(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
        added.push(tag);
      }
      tag.setAttribute("content", content);
    };

    if (settings.og_title) document.title = settings.og_title;
    setMeta("property", "og:title", settings.og_title);
    setMeta("property", "og:description", settings.og_description);
    setMeta("property", "og:image", settings.og_image);
    setMeta("name", "twitter:card", settings.og_image ? "summary_large_image" : "");
    setMeta("name", "twitter:title", settings.og_title);
    setMeta("name", "twitter:description", settings.og_description);
    setMeta("name", "twitter:image", settings.og_image);
    setMeta("name", "description", settings.og_description);

    return () => added.forEach((el) => el.parentNode && el.parentNode.removeChild(el));
  }, [settings]);

  return null;
};
